import { render, staticRenderFns } from "./citizenDetail.vue?vue&type=template&id=1d5c2c62&scoped=true&"
import script from "./citizenDetail.vue?vue&type=script&lang=js&"
export * from "./citizenDetail.vue?vue&type=script&lang=js&"
import style0 from "./citizenDetail.vue?vue&type=style&index=0&id=1d5c2c62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c2c62",
  null
  
)

export default component.exports